/* eslint-disable */
/* tslint:disable */
/* prettier-ignore */
// This file is auto-generated by scripts/generate-tracking-wrapper.ts
// Do not edit manually - changes will be overwritten

import { GnarSpec } from './index'
import {
  objectIdTemplates,
  defaultObjectIdTemplate,
} from '../object-id-templates.config'

/**
 * Wrapper around GnarSpec that automatically computes objectId values
 * using templates defined in object-id-templates.config.ts
 */
export class GnarSpecWrapper {
  constructor(private gnarSpec: GnarSpec) {}

  /**
   * Compute objectId using templates
   */
  private computeObjectId(objectType: string, params: any): string {
    const template = objectIdTemplates[objectType as keyof typeof objectIdTemplates]

    if (template) {
      return template(params as any)
    }

    // Fallback to default template
    return defaultObjectIdTemplate(params)
  }

  /**
   * buttonClick - Wrapper with automatic objectId generation
   */
  async buttonClick(params: {
    displayContent: string
    metadata: { placement: 'Header' | 'Section' | 'Modal' | 'Hero' | 'FloatingHeader', isDisabled?: boolean }
    pageId: string
    pageSlug: string
    objectId?: string
  }): Promise<void> {
    const _objectId = params.objectId ?? this.computeObjectId('button', {
      object: 'button',
      action: 'click',
      ...params,
    })

    return this.gnarSpec.buttonClick(
      params.displayContent,
      params.metadata,
      _objectId,
      params.pageId,
      params.pageSlug
    )
  }

  /**
   * componentShow - Wrapper with automatic objectId generation
   */
  async componentShow(params: {
    componentId: string
    componentType: 'Header' | 'Section' | 'Modal' | 'Hero'
    pageId: string
    pageSlug: string
    objectId?: string
  }): Promise<void> {
    const _objectId = params.objectId ?? this.computeObjectId('component', {
      object: 'component',
      action: 'show',
      ...params,
    })

    return this.gnarSpec.componentShow(
      params.componentId,
      params.componentType,
      _objectId,
      params.pageId,
      params.pageSlug
    )
  }

  /**
   * ctaButtonClick - Wrapper with automatic objectId generation
   */
  async ctaButtonClick(params: {
    ctaType: string
    displayContent: string
    metadata: { placement: 'Header' | 'Section' | 'Modal' | 'Hero' | 'FloatingHeader', styleVariant: 'primary' | 'secondary' | 'tertiary' | 'text', isDisabled?: boolean }
    pageId: string
    pageSlug: string
    targetUrl?: string
    objectId?: string
  }): Promise<void> {
    const _objectId = params.objectId ?? this.computeObjectId('ctaButton', {
      object: 'ctaButton',
      action: 'click',
      ...params,
    })

    return this.gnarSpec.ctaButtonClick(
      params.ctaType,
      params.displayContent,
      params.metadata,
      _objectId,
      params.pageId,
      params.pageSlug,
      params.targetUrl
    )
  }

  /**
   * pageRedirect - Wrapper with automatic objectId generation
   */
  async pageRedirect(params: {
    pageId: string
    pageSlug: string
    redirectUrl: string
    referrer: string
    url: string
    isCustomPage?: boolean
    isStaticFallback?: boolean
    objectId?: string
  }): Promise<void> {
    const _objectId = params.objectId ?? this.computeObjectId('page', {
      object: 'page',
      action: 'redirect',
      ...params,
    })

    return this.gnarSpec.pageRedirect(
      _objectId,
      params.pageId,
      params.pageSlug,
      params.redirectUrl,
      params.referrer,
      params.url,
      params.isCustomPage,
      params.isStaticFallback
    )
  }

  /**
   * pageShow - Wrapper with automatic objectId generation
   */
  async pageShow(params: {
    pageId: string
    pageSlug: string
    referrer: string
    url: string
    isCustomPage?: boolean
    isStaticFallback?: boolean
    objectId?: string
  }): Promise<void> {
    const _objectId = params.objectId ?? this.computeObjectId('page', {
      object: 'page',
      action: 'show',
      ...params,
    })

    return this.gnarSpec.pageShow(
      _objectId,
      params.pageId,
      params.pageSlug,
      params.referrer,
      params.url,
      params.isCustomPage,
      params.isStaticFallback
    )
  }
}
/* eslint-enable */
/* tslint:enable */
